import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './SocialLinks.styles';
const SocialLinks = ({ id, copyright, cta, items, title }) => {
    return (React.createElement(S.Container, { id: id },
        title && React.createElement(S.Title, null, title),
        React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, target: item.target, "aria-label": item.accessibleText },
                React.createElement(S.Icon, { alt: item.text, src: item.icon })))))),
        cta?.text && (React.createElement(LinkButton, { themeOption: "white", href: cta.url, target: cta.target, title: cta.text, "aria-label": cta.accessibleText })),
        copyright && React.createElement(S.Copyright, { dangerouslySetInnerHTML: { __html: copyright } })));
};
export default SocialLinks;
